// src/components/ui/Breadcrumb.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiChevronRight, FiHome } from 'react-icons/fi';

const Breadcrumb = () => {
  const location = useLocation();
  
  // Define breadcrumb mapping
  const breadcrumbMap = {
    '/': { label: 'Dashboard', icon: <FiHome className="w-4 h-4" /> },
    '/scrab': { label: 'Gold Prices' },
    '/update': { label: 'Update Price' },
  };

  // Generate breadcrumb items from current path
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const breadcrumbs = pathSegments.map((segment, index) => {
    const path = '/' + pathSegments.slice(0, index + 1).join('/');
    const breadcrumb = breadcrumbMap[path] || { label: segment };
    
    return {
      ...breadcrumb,
      path,
      isLast: index === pathSegments.length - 1
    };
  });

  return (
    <nav className="flex items-center space-x-1 text-sm text-gray-500 mb-6">
      <Link to="/" className="hover:text-gray-700 flex items-center">
        <FiHome className="w-4 h-4" />
      </Link>
      
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={item.path}>
          <FiChevronRight className="w-4 h-4 text-gray-400" />
          {item.isLast ? (
            <span className="text-gray-900 font-medium flex items-center">
              {item.icon && <span className="mr-1">{item.icon}</span>}
              {item.label}
            </span>
          ) : (
            <Link 
              to={item.path} 
              className="hover:text-gray-700 flex items-center"
            >
              {item.icon && <span className="mr-1">{item.icon}</span>}
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;